module.exports = "/images/arrow-up.svg?15aaa6cbe6f2e0efd459add600cbea5f";